import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IManualUploadsYearMonthFiltersState } from "./interfaces";
import { getYearMonthForUseTaxCalculationFilter } from "utils";

const yearMonth = getYearMonthForUseTaxCalculationFilter();
const initialState: IManualUploadsYearMonthFiltersState = {
  year: yearMonth[0],
  month: yearMonth[1],
};

export const manualUploadsYearMonthFiltersSlice = createSlice({
  name: "manualUploadsYearMonthFilters",
  initialState,
  reducers: {
    updateYear: (state, action: PayloadAction<number>) => {
      state.year = action.payload;
    },
    updateMonth: (state, action: PayloadAction<string>) => {
      state.month = action.payload;
    },
  },
});

export const { updateYear, updateMonth } =
  manualUploadsYearMonthFiltersSlice.actions;

export default manualUploadsYearMonthFiltersSlice.reducer;
